import { ReactNode } from "react";

interface IRenderWhenProps {
  condition: boolean;
  children: ReactNode;
}

interface IIfProps {
  children: ReactNode;
}

export const IfTrue = ({ children }: IIfProps) => <>{children}</>;
export const IfFalse = ({ children }: IIfProps) => <>{children}</>;

export const RenderWhen = ({ condition, children }: IRenderWhenProps) => {
  const childrenArray = Array.isArray(children) ? children : [children];

  const ifTrue = childrenArray.find((child) => (child as any)?.type === IfTrue);
  const ifFalse = childrenArray.find(
    (child) => (child as any)?.type === IfFalse
  );

  if (ifTrue || ifFalse) {
    return <>{condition ? ifTrue : ifFalse}</>;
  }

  return condition ? <>{children}</> : null;
};
